import * as React from "react";
const SvgPlay = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 25 28.12", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m23.53,13.69c.29.17.29.58,0,.74L1.92,26.81c-.31.18-.67-.05-.67-.37V1.68c0-.32.36-.55.67-.37l21.61,12.38Z", fill: "none", strokeWidth: 2.5 }));
export default SvgPlay;
